import React from 'react';
import { useFormContext } from 'react-hook-form';
import useList from 'react-use/lib/useList';
import useDebounce from 'react-use/lib/useDebounce';
import { showErrorNotification } from 'services/common';
import _ from 'lodash';
import { v4 } from 'uuid';
import { Icon, Modal, Upload } from 'antd';

const { Dragger } = Upload;

export default function WholeDirectoryUploader() {
  const form = useFormContext();
  const [files, { push, reset }] = useList([]);
  useDebounce(
    () => {
      if (!files.length) return;
      const matchFolderStructure = path => path.split('/').length === 3;
      if (!files.some(file => matchFolderStructure(file.webkitRelativePath))) {
        showErrorNotification(
          'Directory must be in the following format: <folder_name>/<campaign_name>/<campaign_file>.csv',
        );
        reset();
        return;
      }
      const campaignFiles = form.getValues('campaignFiles');
      const doUploadFolder = () => {
        const parsedFiles = files
          .filter(
            file =>
              file.webkitRelativePath.endsWith('.csv') &&
              matchFolderStructure(file.webkitRelativePath),
          )
          .map(file => {
            const [, campaign, fileName] = file.webkitRelativePath.split('/');
            return {
              campaign,
              fileName,
              file,
            };
          });
        const group = _.groupBy(parsedFiles, 'campaign');
        const values = Object.entries(group).map(([campaign, fileList]) => ({
          id: v4(),
          folder: campaign,
          postExclusionCriteria: {
            domains: [],
            providers: [],
            ranks: [],
            companyNameRegexp: '',
          },
          files: fileList
            .filter(({ fileName }) => fileName.endsWith('.csv'))
            .map(({ file }) => file),
        }));
        form.setValue('campaignFiles', values);
        reset();
      };
      if (campaignFiles.length) {
        Modal.confirm({
          title: 'Are you sure?',
          content:
            'Uploading a whole directory will overwrite all existing campaign files',
          onOk: doUploadFolder,
        });
      } else {
        doUploadFolder();
      }
    },
    100,
    [files],
  );
  return (
    <div>
      <Dragger
        beforeUpload={file => {
          push(file);
          return false;
        }}
        directory
        showUploadList={false}
      >
        <Icon style={{ fontSize: 30 }} type={'upload'} />
        <p className="ant-upload-text">
          You can upload the whole directory of campaign files
        </p>
        <p style={{ color: '#888', fontSize: 12, marginTop: 5 }}>
          Directory must be in the following format:{' '}
          <b>{'<folder_name>/<campaign_name>/<campaign_file>.csv'}</b>. <br />
          Non-csv files will be omitted.
        </p>
      </Dragger>
    </div>
  );
}
